//
//
//
//
//
//
//
//
//
//

  export default {
    name: 'Notify',
    data() {
      return {
        showValue: false,
      };
    },
    props: {
      value: Boolean,
      content: String,
      position: String,
      time: {
        type: Number,
        default: 5000,
      },
    },
    computed: {
      transition() {
        if (this.position === 'bottom') return 'slide-in-up';
        return 'slide-in-down';
      },
      positionClass() {
        if (this.position === 'bottom') {
          return 'notify-bottom';
        }
        return 'notify-top';
      },
    },
    watch: {
      value(val) {
        this.showValue = val;
      },
      showValue(val) {
        this.$emit('input', val);
        if (val) {
          setTimeout(() => {
            this.showValue = !val;
          }, this.time);
        }
      },
    },
    created() {
      if (this.value) {
        this.showValue = this.value;
      }
    },
  };



// WEBPACK FOOTER //
// ./src/components/commons/Notify/index.vue